// copied from /aven_frontend/aven/src/mixins/seonManager.ts

import assert from 'assert'

import seon from '@seontechnologies/seon-javascript-sdk'

import { log } from '@/utils/logger'
import { appSessionStorage, localStorageKey } from '@/utils/storage'
import { OnError, OnSuccess } from './seonManager.types'

export class SeonManager {
    private readonly onSeonSuccess: OnSuccess
    private readonly onSeonError: OnError
    private initialized = false
    private initializedPromise: Promise<boolean> | null = null

    constructor(onSeonSuccess: OnSuccess, onSeonError: OnError) {
        this.onSeonSuccess = onSeonSuccess
        this.onSeonError = onSeonError
    }

    private initInternal = async (): Promise<boolean> => {
        try {
            this.initialized = this.setupSeon()
            return this.initialized
        } catch (error) {
            log.fatal('Seon initialization failed, error:', { error })
            return false
        }
    }

    public init = async (): Promise<boolean> => {
        if (process.env.VUE_APP_NODE_ENV !== 'production') {
            log.info('Not initializing Seon in non-production environment')
            return false
        }

        if (this.initialized) {
            log.info('Seon already initialized')
            return true
        }

        if (this.initializedPromise) {
            log.info('Seon already initializing')
            return this.initializedPromise
        }

        log.info('Initializing Seon...')
        this.initializedPromise = this.initInternal()
        const result = await this.initializedPromise
        this.initializedPromise = null
        return result
    }

    private setupSeon = (): boolean => {
        try {
            const sessionId = appSessionStorage.getItem(localStorageKey.sessionId)
            assert(sessionId)
            seon.config({
                session_id: sessionId,
                onSuccess: this.onSeonSuccess,
                onError: this.onSeonError,
            })
            return true
        } catch (error) {
            log.fatal('Seon initialize failed error:', { error: error as unknown as any })
        }
        return false
    }

    public getSessionFingerprint = async (): Promise<string | undefined> => {
        if (process.env.VUE_APP_NODE_ENV !== 'production') {
            log.info('do not call seon because not in production')
            return undefined
        }
        try {
            log.info('Getting encryptedPayload from Seon SDK...')
            const encryptedPayload = await seon.getBase64Session()
            log.info('Getting encryptedPayload from Seon SDK... Done')
            return encryptedPayload
        } catch (error) {
            log.fatal('Seon get session fingerprint failed error:', { error: error as unknown as any })
        }
        return undefined
    }
}
